import { useState } from "react";
import { useParams } from "@tanstack/react-router";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
// State
import { useInvoiceCard } from "../../state/invoiceCardState";
// Component imports
import InvoiceLines from "./InvoiceLines";
import InvoiceDetails from "./InvoiceDetails";
import { InvoiceCardHeader } from "./InvoiceCardHeader";
// MUI imports
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function InvoiceCard() {
  const { id } = useParams({ strict: false });

  // List of invoices
  const [invoice, setInvoice] = useState({
    companyAddr: [],
    filter: {},
    invoice: {},
  });

  const { isPending, isError, isSuccess, error, data } = useInvoiceCard(id);

  // Success Function
  const successFunc = () => {
    setInvoice(data.data.data.data.data);
  };

  // Error Function
  const errorFunc = () =>
    console.warn(`Error: ${data.data.status}: ${data.data.statusText}`);

  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  return (
    <>
      {isError && <Typography>Error: {error.message}</Typography>}
      <Box>
        <Box>
          {/* <GenericListHeader heading={`Invoice - ${invoice.invoice?.no}`} /> */}
          <InvoiceCardHeader
            heading={`Invoice - ${invoice.invoice?.no}`}
            docNo={invoice.invoice?.no}
          />
          <Box sx={{ pt: 1 }}>
            <InvoiceDetails invoice={invoice.invoice} />
          </Box>
        </Box>
      </Box>
      <Box>
        {invoice.invoice.line ? (
          <Box sx={{ pt: 1 }}>
            <InvoiceLines
              invoiceLines={invoice.invoice?.line}
              currencyCode={invoice.invoice?.currencyCode}
            />
          </Box>
        ) : (
          !isPending && <Typography>No Data</Typography>
        )}
      </Box>
    </>
  );
}
